import React, { Component } from 'react';
import { connect } from 'react-redux';

import { createAttribute } from '../actions/AttributeActions';

import { Pane, Heading, Button } from 'evergreen-ui';
import InfoBlock from '../../common/InfoBlock/InfoBlock';

import { Link } from 'react-router-dom';
import AttributeForm from '../components/AttributeForm';

import Configuration from '../Config';

const validation = Configuration.Validations.attribute;
const defaultValues = Configuration.Defaults.createAttribute;
const mapValidationErrors = Configuration.ErrorHandler.mapValidationErrors;

class CreateAttribute extends Component {
    componentDidMount() {
       
    }

    handleSave = (values) => {
        this.props.dispatch(createAttribute(values));
    }

    render() {
        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/attributes">
                            <Button iconBefore="arrow-left" intent="none">
                                Inapoi la lista atribute
                            </Button>
                        </Link>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Atribut nou
                    </Heading>
                </Pane>
                
                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <InfoBlock flex="1">
                        <AttributeForm 
                            isEdit={false}
                            initialValues={defaultValues}
                            validationSchema={validation}
                            onSave={this.handleSave}
                            errors={this.props.errors}/>
                    </InfoBlock>
                </Pane>

            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        errors: state.attributes.errors.type === 'validation' ? mapValidationErrors(state.attributes.errors.fields): [],
    }
}

export default connect(mapStateToProps)(CreateAttribute);